import { Box, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useLoaderData } from "react-router-dom";
import { PortfolioData } from "../../App.tsx";
import { usePortfolio } from "../../context/PortfolioContext";
import { TABULAR_NUMERALS } from "../general/dataAtoms/shared";

/** How many of all the cases the filters of the portfolio let through. */
export const PortfolioCaseCount = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "portfolio" });
  const { numberOfCases } = usePortfolio();
  const {
    caseCounts: { total },
  } = useLoaderData<PortfolioData>();

  return (
    <Typography
      variant="body2"
      component="span"
      sx={{ color: "text.secondary", ...TABULAR_NUMERALS }}
    >
      <Trans
        t={t}
        i18nKey="caseCounter"
        count={total}
        values={{ current: numberOfCases, total }}
        components={{
          bold: (
            <Box
              component="span"
              sx={{ color: "text.primary", fontWeight: 700 }}
            />
          ),
        }}
      />
    </Typography>
  );
};
